import CreditCardLoginFlow from '../components/login/CreditCardLoginFlow.svelte';
import LandingPage from '../entry/cardEndMain.svelte';

const routes = {
    '/': LandingPage,
    '/login': CreditCardLoginFlow,
    '*': LandingPage
};

export default routes;
